import { VisitLookup } from "../../visits-tab/scripts/visits.lookup";
import { SamplesEvent } from "../scripts/samples.entities";
import { SamplesLookup } from "../scripts/samples.lookup";

export class SamplesSummarySeries {
    name: string;
    type: string;
    typeId: number; 
    sortValue: number;
    samplesByStatus: Map<number, SamplesEvent[]>;
    constructor(name: string, type: string, typeId: number) {
        this.name = name;
        this.type = type;
        this.typeId = typeId;
        if (type === "visit") {
            this.sortValue = VisitLookup.GetVisitMasterOrdering(typeId);
        } else if (type === "sample") {
            this.sortValue = SamplesLookup.GetSampleOrdering(typeId);
        } else {
            this.sortValue = 0;
        }
        //this.sortValue = (type == "visit") ? SamplesLookup.GetVisitFullNameOrdering(typeId) : 0;
        this.samplesByStatus = new Map<number, SamplesEvent[]>();
    }

    addSamplesEvent(event: SamplesEvent): void {
        let samplesArray: SamplesEvent[];
        if (this.samplesByStatus.has(event.SamplesStatusId)) {
            samplesArray = this.samplesByStatus.get(event.SamplesStatusId);
        }
        else {
            samplesArray = [];
        }
        samplesArray.push(event);
        this.samplesByStatus.set(event.SamplesStatusId, samplesArray);

        if (this.type == "site") {
            this.sortValue += 1;
        }
    }
}